import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class MiniAppAccountChoiceItem
*  Элемент списка выбора аккаунта Mini App
*/
export class MiniAppAccountChoiceItem extends ActiveModel {

  /**
  * userId
  * Идентификатор аккаунта пользователя<br>  */
  @ActiveField(0)
  userId: number = 0


/**
  * name
  * Имя из профиля<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * fullName
  * ФИО из профиля<br>
  */
  @ActiveField('')
  fullName: string = ''
}
